import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  containerClassName?: string;
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
  className = '',
  containerClassName = '',
  ...rest
}) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className={`relative ${containerClassName}`.trim()}>
      <input
        {...rest}
        type={isVisible ? 'text' : 'password'}
        className={`w-full border rounded-xl p-3 pr-11 bg-slate-50 outline-none focus:ring-2 focus:ring-purple-500 ${className}`.trim()}
      />
      <button
        type="button"
        onClick={() => setIsVisible((prev) => !prev)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
        aria-label={isVisible ? 'Hide password' : 'Show password'}
      >
        {isVisible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
};
